import { MinimalPageContentWrapper as MinimalPageContent } from "./MinimalPageContent";
import { telehealthIntroRoomRedesignGate } from "../../../statsig/gates";
import { NewIntroRoomContentWrapper as NewIntroRoomContent } from "./NewIntroRoomContent";
import { useFeatureGate } from "@statsig/react-bindings";

export function PageContent() {
  const { value: isIntroRoomRedesignEnabled } = useFeatureGate(
    telehealthIntroRoomRedesignGate,
  );

  if (isIntroRoomRedesignEnabled) {
    return <NewIntroRoomContent />;
  }

  return <MinimalPageContent />;
}
